import type { SVGProps } from 'react';

export function WorldcooLogoIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fill="currentColor"
				d="M13.9777 29.1401C8.87162 29.1401 3.9866 26.9918 0.571568 23.2392C-0.244095 22.3429 -0.178361 20.9595 0.714985 20.1439C1.61132 19.3282 2.99466 19.3939 3.81331 20.2873C6.39774 23.1257 10.1026 24.76 13.9777 24.76C21.498 24.76 27.6169 18.7456 27.6169 11.3449C27.6169 8.50049 26.7236 5.7846 25.0355 3.48999C24.3154 2.51597 24.5276 1.1416 25.5016 0.427518C26.4786 -0.292537 27.85 -0.0804054 28.5641 0.89361C30.8109 3.94712 32 7.56233 32 11.3478C32 21.1627 23.9151 29.146 13.9777 29.146V29.1401Z"
			/>
			<path
				fill="currentColor"
				d="M19.5946 5.13364C20.5387 4.38371 21.931 4.56596 22.6122 5.55791C23.7326 7.18624 24.372 9.16116 24.372 11.2855V11.3572C24.372 16.8965 19.9382 21.5156 13.9238 21.5156C10.936 21.5156 8.34259 20.3683 6.49913 18.5278C5.61176 17.6405 5.6984 16.1765 6.68138 15.3967L6.72022 15.3668C7.61357 14.6617 8.88338 14.814 9.6363 15.6626C10.694 16.8517 12.2118 17.5986 13.9925 17.5986C17.6137 17.5986 19.9023 14.7931 19.9023 11.4319V11.3602C19.9023 10.1113 19.5766 8.94007 18.988 7.9541C18.4472 7.04582 18.6504 5.88059 19.478 5.22029L19.5916 5.13065H19.5946V5.13364Z"
			/>
		</svg>
	);
}
